<template>
  <custom-dialog
    :widthDialog="'800px'"
    :classDialog="'create-dialog custome-dialog'"
    :offsetTop="'3vh'"
    :openDialog="isOpen"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #header>
      <h5 class="dialogTitle margin-left-10">Thêm mới thông tin vai trò</h5>
    </template>

    <template #body>
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        label-position="left"
        label-width="120px"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="Đơn vị" prop="deptIds">
              <template slot="label">
                <span class="label-input">
                  Đơn vị
                  <el-tooltip
                    content="Cây danh mục đơn vị"
                    placement="top"
                    effect="dark"
                  >
                    <i
                      class="fas fa-cog advance-search color__cyan clickable"
                      @click="isOpenSelectDepartmentDialog = true"
                    ></i>
                  </el-tooltip>
                </span>
              </template>
              <el-select
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.deptIds"
                placeholder="Đơn vị"
                size="medium"
                filterable
                clearable
                multiple
                @change="deptIdsChanged"
              >
                <el-option
                  v-for="item in departments"
                  :key="item.id"
                  :label="`${item.deptName} - ${item.identityCode} (${item.parentName})`"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24" v-if="isCxlCaNhan">
            <el-form-item label="Vai trò" prop="roleIds">
              <el-select
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.roleIds"
                placeholder="Vai trò"
                size="medium"
                filterable
                clearable
                multiple
                @change="roleIdsChanged"
              >
                <el-option
                  v-for="item in roles"
                  :key="item.id"
                  :label="item.roleName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24" v-if="isCxlCaNhan">
            <el-form-item label="User" prop="userIds">
              <el-select
                class="input-border__bottom input-border__radius__0 style-fullWidth"
                v-model="form.userIds"
                placeholder="User"
                size="medium"
                filterable
                clearable
                multiple
              >
                <el-option
                  v-for="item in users"
                  :key="item.id"
                  :label="buildUsersLabel(item)"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="5" v-if="isOutgoingFlow && checkPermission">
            <el-form-item label="Loại ký" prop="signIntrustCA">
              <el-checkbox :border="false" v-model="form.signIntrustCA" class="style-fullWidth">Intrust CA</el-checkbox>
            </el-form-item>
          </el-col>

          <el-col :span="5" v-if="isOutgoingFlow && checkPermission">
            <el-form-item prop="signToken">
              <el-checkbox :border="false" v-model="form.signToken" class="style-fullWidth">Ký token</el-checkbox>
            </el-form-item>
          </el-col>


          <el-col :span="6" v-if="isOutgoingFlow && checkPermission">
            <el-form-item prop="signSmartCA">
              <el-checkbox :border="false" v-model="form.signSmartCA" class="style-fullWidth">Smart CA</el-checkbox>
            </el-form-item>
          </el-col>

          <el-col :span="6" v-if="isOutgoingFlow && checkPermission">
            <el-form-item prop="signType">
              <el-checkbox :border="false" v-model="form.signType" class="style-fullWidth">Ký sim CA</el-checkbox>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Hoạt động" prop="status">
              <el-checkbox
                :border="false"
                v-model="form.status"
                class="style-fullWidth"
              >
              </el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template #footer>
      <div class="flex-row form-button__action flex__right">
        <el-button size="medium" type="success" @click="submit">
          <i class="far fa-check-circle font-size__small"></i>
          &nbsp;Lưu
        </el-button>
        <el-button type="info" size="medium" @click="$emit('closeDialog')"
          >Bỏ qua
        </el-button>

        <common-select-department-dialog
          :isOpen="isOpenSelectDepartmentDialog"
          :title="'Chọn đơn vị'"
          :multipleSelect="true"
          v-if="isEnableSelectDepartmentDialog"
          @closed="isEnableSelectDepartmentDialog = false"
          @closeDialog="isOpenSelectDepartmentDialog = false"
          @change="publisherDepartmentChange"
        >
        </common-select-department-dialog>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
import uuidv4 from "uuid/v4";
import constants from "../../../constants";
import departmentService from "../../../services/departmentService";
import h from "../../../services/h";
import roleService from "../../../services/roleService";
import userService from "../../../services/userService";
import utils from "../../../services/utils";
import CommonSelectDepartmentDialog from "../../common/commonSelectDepartmentDialog";
import CustomDialog from "../../common/custom-dialog";

export default {
  name: "vb-step-info-add-dialog",
  components: { CommonSelectDepartmentDialog, CustomDialog },
  props: ["isOpen", "stepType", "isOutgoingFlow"],
  data() {
    return {
      form: {
        deptIds: [],
        parentIds: [],
        roleIds: [],
        userIds: null,
        status: true,
        signType: false,
        signSmartCA: false,
        signIntrustCA: false,
        signToken: false,
      },
      rules: {
        deptIds: [],
        roleIds: [],
        userIds: null,
        status: null,
      },
      departments: [],
      roles: [],
      users: [],

      isOpenSelectDepartmentDialog: false,
      isEnableSelectDepartmentDialog: false,
      // checkPermission: false,
      checkPermission: true,
    };
  },

  computed: {
    isCxlCaNhan() {
      return this.stepType === constants.STEP.STEP_TYPE.CANHAN;
    },
    isCxlDonVi() {
      return this.stepType === constants.STEP.STEP_TYPE.DONVI;
    },
  },

  watch: {
    isOpenSelectDepartmentDialog(newValue) {
      newValue && (this.isEnableSelectDepartmentDialog = newValue);
    },
  },

  async created() {
    await this.loadDepartments();
    await this.loadRoles();
    this.initComponent();
  },

  methods: {
    publisherDepartmentChange({ selectedDepartments }) {
      this.form.deptIds = h.collect(
        selectedDepartments,
        (department) => department.id
      );
      this.isOpenSelectDepartmentDialog = false;
    },

    deptIdsChanged() {
      this.form.parentIds = this.departments.filter(d => this.form.deptIds.includes(d.id)).map(d => d.parentId);
      this.form.userIds = [];
      this.loadUsers();
    },

    roleIdsChanged(value) {
      // if (value && value.length === 1) {
      //   let currentRole = this.roles.find((item) => item.id === value[0]);
      //   if (currentRole.roleCode === constants.ROLE.CODE.LANH_DAO) {
      //     this.checkPermission = true;
      //   } else {
      //     this.checkPermission = false;
      //   }
      // } else {
      //   this.checkPermission = false;
      // }

      // todo hiển thị tất cả loại kí
      this.checkPermission = true;
      this.form.userIds = [];
      this.loadUsers();
    },

    loadUsers() {
      return (this.form.deptIds && this.form.deptIds.length
        ? userService
            .findall({
              deptIds: this.form.deptIds,
              roleIds: this.form.roleIds,
              status: constants.STATUS_.ACTIVE,
            })
            .then((response) => response.data)
        : Promise.resolve([])
      ).then((users) => (this.users = users));
    },

    loadDepartments() {
      return departmentService
        .findAll2({ status: constants.STATUS_.ACTIVE }, { sort: "path,asc" })
        .then((response) => (this.departments = response.data));
    },

    loadRoles() {
      return roleService
        .findAll(
          {
            roleCodes: [
              constants.ROLE.CODE.LANH_DAO,
              constants.ROLE.CODE.CHUYEN_VIEN,
              constants.ROLE.CODE.VAN_THU,
            ],
          },
          { sort: "roleName,asc" }
        )
        .then((response) => (this.roles = response.data));
    },

    buildUsersLabel(user) {
      return `${user.fullName} (${user.userName})`;
    },

    /**
     * populate thêm các thông tin tên để hiển thị;
     * @param vbStepInfoForm
     */
    async populateExtendData(vbStepInfoForm) {
      vbStepInfoForm.fullName = this.getFullName(vbStepInfoForm.userId);
      vbStepInfoForm.roleName = this.getRoleName(vbStepInfoForm.roleId);
      vbStepInfoForm.deptName = this.getDeptName(vbStepInfoForm.deptId);
    },

    getFullName(userId) {
      if (!userId) return "-";
      let user = h.find(this.users, (user) => user.id === userId);
      return user ? user.fullName : "-";
    },

    getRoleName(roleId) {
      if (!roleId) return "-";
      let role = h.find(this.roles, (role) => role.id === roleId);
      return role ? role.roleName : "-";
    },

    getDeptName(deptId) {
      if (!deptId) return "-";
      let department = h.find(
        this.departments,
        (department) => department.id === deptId
      );
      return department ? department.deptName : "-";
    },

    async convertToSubmitForm() {
      let vbStepInfoForms = [];

      let deptIds =
        this.form.deptIds && this.form.deptIds.length
          ? this.form.deptIds
          : [null];
      let parentIds =
        this.form.parentIds && this.form.parentIds.length
          ? this.form.parentIds
          : [null];
      let roleIds =
        this.form.roleIds && this.form.roleIds.length
          ? this.form.roleIds
          : [null];
      let userIds =
        this.form.userIds && this.form.userIds.length
          ? this.form.userIds
          : [null];

      h.each(deptIds, (deptId, index) => {
        h.each(roleIds, (roleId) => {
          h.each(userIds, (userId) => {
            vbStepInfoForms.push({
              id: uuidv4(),
              deptId,
              parentId: parentIds[index],
              roleId,
              userId,
              signType: this.form.signType,
              signIntrustCA: this.form.signIntrustCA,
              signSmartCA: this.form.signSmartCA,
              signToken: this.form.signToken,
              status: this.form.status
                ? constants.STATUS_.ACTIVE
                : constants.STATUS_.DEACTIVE,
            });
          });
        });
      });

      return Promise.all(
        h.collect(vbStepInfoForms, (vbStepForm) =>
          this.populateExtendData(vbStepForm)
        )
      ).then(() => vbStepInfoForms);
    },

    submit() {
      return this.validateForm()
        .then(() => this.convertToSubmitForm())
        .then((forms) => {
          this.$emit("submit", { forms });
        });
    },

    validateForm() {
      return utils.validateFormCommon(this.$refs.form, this.$message);
    },

    initValidationRules() {
      let defaultRequiredConstrains = utils.buildRequiredValidationConstrains();
      this.rules.deptIds = [defaultRequiredConstrains];
    },

    initComponent() {
      this.initValidationRules();
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/setting/cau-hinh-luong-v2/vb-step-info-add-dialog.vue